import { useCallback, useEffect, useState } from 'react';
import { TFile } from 'types/user';
import { useNavigate, useParams } from 'react-router-dom';
import { getFilesById } from 'services/files';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

export const useArchiveDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [file, setFile] = useState<TFile>();

  const getInitFile = useCallback(async () => {
    const { file } = await getFilesById(Number(id));
    setFile(file);
  }, [id]);

  const { asyncCallback: asyncGetInitFiles } = useAsyncCallback(getInitFile, []);

  useEffect(() => {
    asyncGetInitFiles();
  }, [id]);

  const handleOnBack = () => navigate(-1);

  return {
    dataDetail: file,
    handleOnBack
  };
};
